<template>
  <div v-if="detail" class="box">
    <CustomNavBar :title="detail.title" />
    <van-list class="list">
      <van-cell>
        <div v-if="detail.three_status" class="card" @click="onOpenPano(detail)">
          <img class="link__pano" :src="detail.images" alt="">
          <div class="link__btn">
            <img :src="require('@/assets/more.png')" alt="">
          </div>
        </div>
      </van-cell>
      <van-cell>
        <div class="desc" v-html="detail.description" />
      </van-cell>
    </van-list>
  </div>
</template>

<script>
import { scenicInfo } from "@/api/scenic";
import CustomNavBar from "@/components/CustomNavBar";
export default {
  name: "DETAIL",
  components: {
    CustomNavBar,
  },
  data() {
    return {
      detail: null,
    };
  },
  created() {
    this.getData();
  },
  mounted() {
    this.$store.commit('set_istab', false)
  },
  methods: {
    onOpenPano(item) {
      this.$router.push({
        path: "/pano",
        query: {
          id: item.id
        },
      });
    },

    getData() {
      const query = this.$route.query;
      scenicInfo(query).then((ret) => {
        this.detail = ret;
      });
    },
  },
};
</script>

<style lang="scss" scoped>

@media screen and (min-width:800px) {
  .list{
    width: 800px;
    margin:auto
  }
}
.box {
  width: 100%;
  height: 100%;
  background: #f5f7fa;

  .is_tab {
    height: calc(100% - 96px) !important;
  }

  .list {
    height: calc(100% - 46px);
    overflow: auto;
    background-color: #fff;

    .card {
      margin: 5px 16px;
      box-sizing: border-box;
      border-radius: 8px;
      overflow: hidden;
      max-height: 300px;
      position: relative;

      .link__pano {
        height: auto;
        min-height: 200px;
        max-height: 300px;
        width: 100%;
        object-fit: cover;
        z-index: 1;
      }
      .link__btn {
        position: absolute;
        bottom: 20%;
        width: 100%;
        color: #fff;
        font-size: 16px;
        font-weight: bold;
        z-index: 999;

        img{
          background-color: rgba(0, 0, 0, 0.5);
          padding: 10px;
          width: 100px;
          margin: auto;
          border-radius: 5px
        }
      }
    }

    .desc {
      margin: 5px 16px;
      margin-top: 20px;

      ::v-deep p{
        width: 100%;
        text-indent: 2em;
        white-space: pre-wrap;
        word-break: break-all;
        word-wrap: break-word;
      }

      ::v-deep img {
        border-radius: 8px;
        width: 100% !important;
      }
    }
  }
}

@keyframes linkBtn {
  0%{
    transform: scale(0.8);

  }
  50%{
    transform: scale(1);
  }
  100%{
    transform: scale(0.8);
  }
}
</style>
